module.exports = __webpack_public_path__ + "static/media/Pionexlogo@2x.8547e414.svg";